export default __webpack_public_path__ + "static/media/requested hours.8d508b23.svg";